module.exports = __webpack_public_path__ + "img/4.37f7fd8b.png";